// front-end/src/components/block-system/block-configs/block-types/course-card.js

export function createCourseCard(block, parent) {
    const blockName = block.data_block_name;
    const isMobile = window.innerWidth <= 768;

    // Создаем основной контейнер курса
    const courseCard = document.createElement('div');
    courseCard.className = 'course-card container-fluid';
    courseCard.setAttribute('data-block-name', blockName);

    if (block.id && block.id !== 'undefined') {
        courseCard.setAttribute('data-block-id', block.id);
    }

    if (block.order !== undefined && block.order !== null) {
        courseCard.setAttribute('data-order', String(block.order));
    } else {
        courseCard.setAttribute('data-order', '0');
    }

    courseCard.style.position = 'relative';

    // ВАЖНО: Добавляем атрибуты для работы с course системой
    if (block.course_id) {
        courseCard.setAttribute('data-course-id', block.course_id);
    }
    if (block.course_status) {
        courseCard.setAttribute('data-course-status', block.course_status);
    }
    if (block.course_slug) {
        courseCard.setAttribute('data-course-slug', block.course_slug);
    }

    // Определяем активность ссылки на основе статуса
    const isActiveLink = block.course_status === 'published' || block.id;
    const courseHref = isActiveLink && block.course_slug ? `/course/${block.course_slug}` : '#';

    // ВАЖНО: Проверяем авторизацию для показа статуса
    const {isAuthenticated} = require('../../../auth');
    const showStatusIndicator = isAuthenticated() && block.course_status;

    // Разная разметка для мобильных и десктопа
    if (isMobile) {
        // language=HTML
        courseCard.innerHTML = `
            <div class="accordion-main course-accordion">
                <div class="row">
                    <div class="col-12">
                        <div class="course-header d-flex justify-content-between align-items-center">
                            <h4 class="course-name" data-content="${blockName}-title" data-global="true"></h4>
                            <button class="open-accordion"
                                    style="background: none; border: none; cursor: pointer; padding: 0;">
                                <img src="/images/accordion-closed.svg" alt="open"
                                     style="width: 24px; height: 24px;">
                            </button>
                            <button class="close-accordion"
                                    style="background: none; border: none; cursor: pointer; display: none; padding: 0;">
                                <img src="/images/opened-accordion.svg" alt="close"
                                     style="width: 24px; height: 24px;">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="accordion-inner" style="max-height: 0; overflow: hidden; transition: max-height 0.3s ease;">
                    <div class="row mt-3">
                        <div class="col-12">
                            <img  class="course-image" src="" data-content="${blockName}-image" data-type="image" data-global="true">
                            
                            <p class="course-block-description" data-content="${blockName}-description" data-type="textarea" data-global="true"></p>

                            <div class="all-tags mb-3">
                                <div class="course-tags-container">
                                    <div class="course-tag">
                                        <p data-content="${blockName}-location" data-global="true"></p>
                                    </div>
                                    <div class="course-tag">
                                        <p data-content="${blockName}-duration" data-global="true"></p>
                                    </div>
                                    <div class="course-tag">
                                        <p data-content="${blockName}-price" data-global="true"></p>
                                    </div>
                                </div>
                            </div>

                            <a href="${courseHref}"
                               class="news-link-to-feed-container ${isActiveLink ? 'active' : 'inactive'} mt-3">
                                Дізнатися більше
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            ${showStatusIndicator ? `
            <div class="course-status-indicator status-${block.course_status}">
                <span class="status-text">${block.course_status.toUpperCase()}</span>
            </div>
            ` : ''}
        `;
    } else {
        // language=HTML
        courseCard.innerHTML = `
            <div class="row">
                <div class="pd-container-course col-lg-6 col-md-6">
                    <img class="course-image" src="" data-content="${blockName}-image" data-type="image"
                         data-global="true">
                </div>
                <div class="pd-top-container-course col-lg-6 col-md-6">
                    <h4 class="course-name" data-content="${blockName}-title" data-global="true"></h4>
                    <div class="course-tags-container">
                        <div class="course-tag">
                            <p data-content="${blockName}-location" data-global="true"></p>
                        </div>
                        <div class="course-tag">
                            <p data-content="${blockName}-duration" data-global="true"></p>
                        </div>
                        <div class="course-tag">
                            <p data-content="${blockName}-price" data-global="true"></p>
                        </div>
                    </div>
                    <a href="${courseHref}" class="news-link-to-feed-container ${isActiveLink ? 'active' : 'inactive'}">
                        Дізнатися більше
                    </a>
                </div>
            </div>
            ${showStatusIndicator ? `
            <div class="course-status-indicator status-${block.course_status}">
                <span class="status-text">${block.course_status.toUpperCase()}</span>
            </div>
            ` : ''}
        `;
    }

    parent.appendChild(courseCard);

    // Инициализируем аккордеон на мобильных
    if (isMobile) {
        setTimeout(() => initializeCourseAccordion(courseCard), 100);
    }

    return courseCard;
}

// Функция инициализации аккордеона для курса
function initializeCourseAccordion(courseCard) {
    const accordion = courseCard.querySelector('.course-accordion');
    if (!accordion) return;

    const openBtn = accordion.querySelector('.open-accordion');
    const closeBtn = accordion.querySelector('.close-accordion');
    const accordionInner = accordion.querySelector('.accordion-inner');
    const header = accordion.querySelector('.course-header');

    if (openBtn && closeBtn && accordionInner && header) {
        // Делаем хедер кликабельным
        header.style.cursor = 'pointer';

        // Обработчик на весь хедер
        header.addEventListener('click', (e) => {
            if (!e.target.closest('.open-accordion') && !e.target.closest('.close-accordion')) {
                const isOpen = accordionInner.classList.contains('open');
                toggleCourseAccordion(accordion, !isOpen);
            }
        });

        // Обработчики на кнопки
        openBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleCourseAccordion(accordion, true);
        });

        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleCourseAccordion(accordion, false);
        });
    }
}

// Функция переключения аккордеона
function toggleCourseAccordion(accordion, shouldOpen) {
    const accordionInner = accordion.querySelector('.accordion-inner');
    const openBtn = accordion.querySelector('.open-accordion');
    const closeBtn = accordion.querySelector('.close-accordion');
    const headerTextElements = accordion.querySelectorAll('.course-header h4, .course-header p');
    const innerTextElements = accordionInner.querySelectorAll('h4, p, a');
    const courseBlock = accordion.closest('.course-card');

    if (shouldOpen) {
        // Открываем
        accordionInner.style.display = 'block';
        setTimeout(() => {
            const scrollHeight = accordionInner.scrollHeight;
            accordionInner.style.maxHeight = scrollHeight + 'px';
        }, 10);

        accordionInner.classList.add('open');
        accordion.classList.add('accordion-container-open');

        // Добавляем градиентный фон
        courseBlock.style.background = 'linear-gradient(143deg, #19b5e1 0%, #0090b8 100%)';

        // Меняем цвет текста на белый
        headerTextElements.forEach(el => {
            el.classList.add('text-color-white');
            el.style.setProperty('color', 'white', 'important');
        });

        innerTextElements.forEach(el => {
            // Проверяем, не находится ли элемент внутри .course-tag
            if (!el.closest('.course-tag')) {
                el.classList.add('text-color-white');
                el.style.setProperty('color', 'white', 'important');
            }
        });

        openBtn.style.display = 'none';
        closeBtn.style.display = 'inline-block';
    } else {
        // Закрываем
        accordionInner.style.maxHeight = '0';
        accordionInner.classList.remove('open');
        accordion.classList.remove('accordion-container-open');

        // Убираем градиентный фон
        courseBlock.style.removeProperty('background');

        // Возвращаем исходный цвет текста
        headerTextElements.forEach(el => {
            el.classList.remove('text-color-white');
            el.style.removeProperty('color');
        });

        innerTextElements.forEach(el => {
            // Возвращаем исходный цвет текста, но не трогаем элементы в .course-tag
            if (!el.closest('.course-tag')) {
                el.classList.remove('text-color-white');
                el.style.removeProperty('color');
            }
        });

        setTimeout(() => {
            openBtn.style.display = 'inline-block';
            closeBtn.style.display = 'none';
            accordionInner.style.display = 'none';
        }, 300);
    }
}

// Глобальный обработчик ресайза для курсов
let courseResizeTimeout;
let previousIsMobile = window.innerWidth <= 768;

function setupCourseResizeHandler() {
    // Проверяем, не установлен ли уже обработчик
    if (window.courseResizeHandlerInitialized) return;
    window.courseResizeHandlerInitialized = true;

    window.addEventListener('resize', () => {
        clearTimeout(courseResizeTimeout);
        courseResizeTimeout = setTimeout(() => {
            const currentIsMobile = window.innerWidth <= 768;

            // Если режим изменился
            if (previousIsMobile !== currentIsMobile) {
                console.log('[CourseCard] Режим изменился, перестраиваем блоки');
                previousIsMobile = currentIsMobile;
                rebuildAllCourseCards(currentIsMobile);
            }
        }, 150);
    });
}

// Функция перестройки всех карточек курсов
function rebuildAllCourseCards(isMobile) {
    // Находим все карточки курсов
    const courseCards = document.querySelectorAll('.course-card[data-block-name^="course-card-"]');
    console.log(`[CourseCard] Найдено ${courseCards.length} карточек для перестройки`);

    courseCards.forEach(card => {
        const blockName = card.getAttribute('data-block-name');
        const blockId = card.getAttribute('data-block-id');
        const order = card.getAttribute('data-order');
        const courseId = card.getAttribute('data-course-id');
        const courseStatus = card.getAttribute('data-course-status');
        const courseSlug = card.getAttribute('data-course-slug');

        // Сохраняем контент
        const contentData = {};
        const contentElements = card.querySelectorAll('[data-content]');
        contentElements.forEach(el => {
            const tagId = el.getAttribute('data-content');
            if (el.tagName === 'IMG') {
                contentData[tagId] = el.src;
            } else {
                contentData[tagId] = el.textContent || el.innerText || '';
            }
        });

        // Создаем объект блока
        const blockData = {
            data_block_name: blockName,
            id: blockId,
            order: parseInt(order) || 0,
            course_id: courseId,
            course_status: courseStatus,
            course_slug: courseSlug
        };

        // Пересоздаем блок
        const parent = card.parentElement;
        const newCard = createCourseCard(blockData, document.createElement('div'));

        // Восстанавливаем контент
        Object.keys(contentData).forEach(tagId => {
            const element = newCard.querySelector(`[data-content="${tagId}"]`);
            if (element) {
                if (element.tagName === 'IMG') {
                    element.src = contentData[tagId];
                } else {
                    element.textContent = contentData[tagId];
                }
            }
        });

        // Заменяем старую карточку новой
        parent.replaceChild(newCard, card);

        // Если нужны кнопки редактирования/удаления - добавьте их тут
        const {isAuthenticated} = require('../../../auth');
        if (isAuthenticated()) {
            // Тут можно добавить контролы для редактирования
            // addDeleteButton(newCard, blockId);
            // setupEditButtons(newCard);
        }
    });

    console.log('[CourseCard] Перестройка завершена');
}

// Инициализируем обработчик при загрузке
if (typeof window !== 'undefined') {
    setupCourseResizeHandler();
}

// Функция для извлечения номера из имени блока
function getBlockNumber(blockName) {
    const match = blockName.match(/-(\d+)$/);
    return match ? match[1] : '1';
}

export const courseCardProps = {
    name: 'course-card',
    title: 'Картка курсу',
    description: 'Блок для відображення курсу',
    allowedParents: ['courses-section'],
    contentFields: [
        {name: 'title', type: 'text', label: 'Назва курсу'},
        {name: 'description', type: 'textarea', label: 'Опис'},
        {name: 'image', type: 'image', label: 'Зображення'},
        {name: 'location', type: 'text', label: 'Локація'},
        {name: 'duration', type: 'text', label: 'Тривалість'},
        {name: 'price', type: 'text', label: 'Вартість'}
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview course-card-preview">
                <div class="row">
                    <div class="col-6">
                        <div class="image-placeholder"></div>
                    </div>
                    <div class="col-6">
                        <h4>${data.title || 'Назва курсу'}</h4>
                        <p>${data.description || 'Опис курсу...'}</p>
                        <div class="tags">
                            <span class="tag">${data.location || 'Локація'}</span>
                            <span class="tag">${data.duration || 'Тривалість'}</span>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
};